import { Container, Grid, Typography } from "@mui/material";
import React from "react";
import "./gallery.css";
import { Link } from "react-router-dom";
import { galleryType } from "../../ApiServices/config";
import Masonry from "@mui/lab/Masonry";
import VideoPlaylist from "./Videos";
import useGalleryData from "./customHook";

function Gallery({ type }) {
  const { gallery } = useGalleryData(type);

  return (
    <>
      <Container className="gallery-bg py-5">
        <Grid className="container pt-4">
          <Grid className="text-center">
            <h6 className="section-title text-center text-primary text-uppercase title-tl">
              Temple
            </h6>
            <h1>
              <span className="text-secundary">Gallery</span>
            </h1>
          </Grid>

          <Grid container justifyContent="center">
            {type === galleryType.photo ? (
              gallery.list?.length > 0 ? (
                <Masonry columns={{ xs: 1, sm: 2 }} spacing={2}>
                  {gallery.list?.map((event) => (
                    <Link to={`/gallery/photos/${event.slug}`} key={event.slug}>
                      <Grid className="gallery-background-image">
                        <img src={event.image} alt="" />
                      </Grid>
                      <Typography variant="h5" textAlign="center">
                        {event.name}
                      </Typography>
                    </Link>
                  ))}
                </Masonry>
              ) : (
                "Currently there are no events gallery, please check in future for all updated event gallery."
              )
            ) : (
              <VideoPlaylist gallery={gallery} />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Gallery;
